import React, {Component} from 'react';
import {Alert} from "reactstrap";
import {SelectAdgroupsMultiSelectModal, SelectCampaignsMultiSelectModal} from "./SelectItemsMultiSelectModal";
import {FaIcon} from "../../FaIcon";
import BudgetValueInput from "../../elements/BudgetValueInput";
import {BUDGET, CAMPAIGN_ID, CAMPAIGN_NAME, ADGROUP_ID, ADGROUP_NAME, ImportFromCSVModal} from "./ImportFromCSVModal";
import {HELP_INCLUDE_CAMPAIGNS_AUTOMATICALLY, LinkToArticle} from "../../help_center/LinkToArticle";
import { withTranslation } from 'react-i18next';

export const METHOD_INCLUDE_ALL_CAMPAIGNS = "INCLUDE_ALL_CAMPAIGNS";
export const METHOD_SELECT_CAMPAIGNS_FROM_LIST = "SELECT_CAMPAIGNS_FROM_LIST";
export const METHOD_INCLUDE_CAMPAIGN_ON_CONDITION = "INCLUDE_CAMPAIGN_ON_CONDITION";
export const METHOD_SELECT_ADGROUPS_FROM_LIST = "SELECT_ADGROUPS_FROM_LIST";
export const METHOD_INCLUDE_ADGROUP_ON_CONDITION = "INCLUDE_ADGROUP_ON_CONDITION";

export const METHODS_DATA = {
    [METHOD_INCLUDE_ALL_CAMPAIGNS]: {'Spanish': 'Siempre incluir todas las campañas de la cuenta', 'selectingCampaigns': true, 'selectingAdgroups': false},
    [METHOD_SELECT_CAMPAIGNS_FROM_LIST]: {'Spanish': 'Voy a seleccionar las campañas desde el listado', 'selectingCampaigns': true, 'selectingAdgroups': false},
    [METHOD_INCLUDE_CAMPAIGN_ON_CONDITION]: {'Spanish': 'Incluir automáticamente las campañas que cumplen condición', 'selectingCampaigns': true, 'selectingAdgroups': false},
    [METHOD_SELECT_ADGROUPS_FROM_LIST]: {'Spanish': 'Voy a seleccionar ciertos grupos de anuncios desde el listado', 'selectingCampaigns': false, 'selectingAdgroups': true},
    [METHOD_INCLUDE_ADGROUP_ON_CONDITION]: {'Spanish': 'Incluir automáticamente los grupos de anuncios que cumplen condición', 'selectingCampaigns': false, 'selectingAdgroups': true}
};

class AccountCampaignsConfigurationClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            onlyMethodSelectCampaignsFromList: this.props.onlyMethodSelectCampaignsFromList,
            onlyMethodSelectAdgroupsFromList: this.props.onlyMethodSelectAdgroupsFromList,
            selectionMethod: this._defaultSelectionMethod(),
            selectedCampaigns: this.props.selectedCampaigns !== null && this.props.selectedCampaigns !== undefined ? this.props.selectedCampaigns : [],
            selectedAdgroups: this.props.selectedAdgroups !== null && this.props.selectedAdgroups !== undefined ? this.props.selectedAdgroups : [],
            itemBudgetEdition: this.props.budgetPerItemModeOn,
            conditionIncludeText: this.props.conditionIncludeText !== undefined ? this.props.conditionIncludeText : "",
            conditionExcludeText: this.props.conditionExcludeText !== undefined ? this.props.conditionExcludeText : "",
            allActiveCampaigns: this.props.allActiveCampaigns || [],
            allActiveAdgroups: this.props.allActiveAdgroups || [],
            // Esto se usa para poder mostrar las campañas o adgroups seleccionados que no están activos si es que selecciona el método de seleccion
            // a mano de campañas o adgroups desde el listado
            someSelectedNotActiveCampaignsData: this.props.someSelectedNotActiveCampaignsData || [],
            someSelectedNotActiveAdgroupsData: this.props.someSelectedNotActiveAdgroupsData || [],
            // Esto se trae solo si quiero usar el importador de campañas o adgroups desde un archivo CSV
            // O si quiere seleccionar campañas o adgroups no activos
            allNotActiveCampaigns: null,
            allNotActiveAdgroups: null
        }
        this.state = {
            ...this.state,
            allocatedBudgetByAccountIdAndItemId: this.initializeAllocatedBudgetByAccountIdAndItemId()
        };

        this.handleSelectionMethodChange = this.handleSelectionMethodChange.bind(this);
        this.handleAddItems = this.handleAddItems.bind(this);
        this.handleImportFromJson = this.handleImportFromJson.bind(this);
        this.handleRemoveItem = this.handleRemoveItem.bind(this);
        this.handleIncludeTextChange = this.handleIncludeTextChange.bind(this);
        this.handleExcludeTextChange = this.handleExcludeTextChange.bind(this);
        this.handleAllocatedBudgetChange = this.handleAllocatedBudgetChange.bind(this);

    }

    _defaultSelectionMethod() {
        return this.props.onlyMethodSelectCampaignsFromList !== true ? this.props.campaignsSelectionMethod : METHOD_SELECT_CAMPAIGNS_FROM_LIST;
    }

    componentDidUpdate(prevProps) {
        // Ya no se puede cambiar la cuenta
        // if (this.props.selectedAccountId !== prevProps.selectedAccountId) {
        //     const allocatedBudgetByAccountIdAndItemId = this.state.allocatedBudgetByAccountIdAndItemId;
        //
        //     const strAccountId = this.props.selectedAccountId.toString();
        //     if (this.state.allocatedBudgetByAccountIdAndItemId[strAccountId] === undefined)
        //         allocatedBudgetByAccountIdAndItemId[strAccountId] = {};
        //
        //     this.setState({
        //         allocatedBudgetByAccountIdAndItemId: allocatedBudgetByAccountIdAndItemId,
        //         selectedCampaigns: [],
        //         selectedAdgroups: [],
        //     });
        // }

        if(this.props.lastEntitiesUpdatedOn !== prevProps.lastEntitiesUpdatedOn || (this.state.allNotActiveCampaigns === null && this.props.allNotActiveCampaigns) || (this.state.allNotActiveAdgroups === null && this.props.allNotActiveAdgroups)) {
            this.setState({
                ...this.state,
                allActiveCampaigns: this.props.allActiveCampaigns || [],
                allActiveAdgroups: this.props.allActiveAdgroups || [],
                someSelectedNotActiveCampaignsData: this.props.someSelectedNotActiveCampaignsData || [],
                someSelectedNotActiveAdgroupsData: this.props.someSelectedNotActiveAdgroupsData || [],
                allNotActiveCampaigns: this.props.allNotActiveCampaigns ? this.props.allNotActiveCampaigns : this.state.allNotActiveCampaigns,
                allNotActiveAdgroups: this.props.allNotActiveAdgroups ? this.props.allNotActiveAdgroups : this.state.allNotActiveAdgroups,
            });
        }
    }

    initializeAllocatedBudgetByAccountIdAndItemId() {
        const dic = {};
        let allocatedBudget = null;
        let sItemId = null;

        const items = this.isSelectionMethodSelectingCampaigns() ? this._getCampaignsData() : (this.isSelectionMethodSelectingAdgroups() ? this._getAdgroupsData() : null);
        if (!items)
            return {};

        items.forEach((item) => {
            sItemId = item.id.toString();
            allocatedBudget = this.props.allocatedBudgetByItem === null ||this.props.allocatedBudgetByItem === undefined || this.props.allocatedBudgetByItem[sItemId] === undefined ? 0 : this.props.allocatedBudgetByItem[sItemId];
            dic[sItemId] = allocatedBudget;
        });

        return {[this.props.selectedAccountId.toString()]: dic};
    }

    handleAllocatedBudgetChange(itemId, allocatedBudget) {
        const allocatedBudgetByAccountIdAndItemId = this.state.allocatedBudgetByAccountIdAndItemId;
        const strAccountId = this.props.selectedAccountId.toString();
        const strItemId = itemId.toString();
        if (allocatedBudgetByAccountIdAndItemId[strAccountId] === undefined)
            allocatedBudgetByAccountIdAndItemId[strAccountId] = {};
        allocatedBudgetByAccountIdAndItemId[strAccountId][strItemId] = allocatedBudget;
        this.setState({allocatedBudgetByAccountIdAndItemId: allocatedBudgetByAccountIdAndItemId});
        this.props.onItemBudgetChange(allocatedBudgetByAccountIdAndItemId[strAccountId], null, null);
    }

    handleIncludeTextChange(event) {
        const newValue = event.target.value;
        const strAccountId = this.props.selectedAccountId.toString();

        // Si estoy trabajando con Campañas o Adgroups
        if(this.isSelectionMethodSelectingCampaigns() || this.isSelectionMethodSelectingAdgroups()) {
            const allocatedBudgetByAccountIdAndItemId = this.state.allocatedBudgetByAccountIdAndItemId;
            const filteredItems = this.filterItemsOnConditions(newValue, this.state.conditionExcludeText);
            this.updateBudgetForSelectedItems(filteredItems.map((item) => item.id), allocatedBudgetByAccountIdAndItemId[strAccountId]);

            this.setState({
                conditionIncludeText: newValue,
                allocatedBudgetByAccountIdAndItemId: allocatedBudgetByAccountIdAndItemId
            });

            this.props.onIncludeTextChange(newValue, allocatedBudgetByAccountIdAndItemId[strAccountId]);
        }
        else {
            throw new Error('Method not implemented.');
        }
    }

    isSelectionMethodSelectingCampaigns() {
        const selectionMethod = this.state === undefined ? this._defaultSelectionMethod() : this.state.selectionMethod;
        return selectionMethod === METHOD_INCLUDE_ALL_CAMPAIGNS || selectionMethod === METHOD_INCLUDE_CAMPAIGN_ON_CONDITION || selectionMethod === METHOD_SELECT_CAMPAIGNS_FROM_LIST;
    }

    isSelectionMethodSelectingAdgroups() {
        const selectionMethod = this.state === undefined ? this._defaultSelectionMethod() : this.state.selectionMethod;
        return selectionMethod === METHOD_INCLUDE_ADGROUP_ON_CONDITION || selectionMethod === METHOD_SELECT_ADGROUPS_FROM_LIST;
    }

    handleExcludeTextChange(event) {
        const newValue = event.target.value;
        const strAccountId = this.props.selectedAccountId.toString();

        // Si estoy trabajando con Campañas o adgroups
        if(this.isSelectionMethodSelectingCampaigns() || this.isSelectionMethodSelectingAdgroups()) {
            const allocatedBudgetByAccountIdAndItemId = this.state.allocatedBudgetByAccountIdAndItemId;
            const filteredItems = this.filterItemsOnConditions(this.state.conditionIncludeText, newValue);
            this.updateBudgetForSelectedItems(filteredItems.map((Item) => Item.id), allocatedBudgetByAccountIdAndItemId[strAccountId]);

            this.setState({
                conditionExcludeText: newValue,
                allocatedBudgetByAccountIdAndItemId: allocatedBudgetByAccountIdAndItemId
            });
            this.props.onExcludeTextChange(newValue, allocatedBudgetByAccountIdAndItemId[strAccountId]);
        } else {
            throw new Error('Method not implemented.');
        }
    }

    updateBudgetForSelectedItems(selectedItems, allocatedBudgetByItemId) {
        // Borra las que no van mas
        Object.keys(allocatedBudgetByItemId).forEach(strItemId => {
            if (!selectedItems.includes(strItemId)) {
                delete allocatedBudgetByItemId[strItemId];
            }
        });

        // Agrega las nuevas
        selectedItems.forEach(strItemId => {
            if (allocatedBudgetByItemId[strItemId] === undefined)
                allocatedBudgetByItemId[strItemId] = 0;
        });
    }

    handleRemoveItem(itemId) {
        const selectedCampaigns = this.isSelectionMethodSelectingCampaigns() ? this.state.selectedCampaigns.filter((c) => (c !== itemId.toString())) : [];
        const selectedAdgroups = this.isSelectionMethodSelectingAdgroups() ? this.state.selectedAdgroups.filter((c) => (c !== itemId.toString())) : [];
        const selectedItems = selectedCampaigns.concat(selectedAdgroups); // Uno siempre va a estar vacio
        const strAccountId = this.props.selectedAccountId.toString();
        const allocatedBudgetByAccountIdAndItemId = this.state.allocatedBudgetByAccountIdAndItemId;
        this.updateBudgetForSelectedItems(selectedItems, allocatedBudgetByAccountIdAndItemId[strAccountId]);

        this.setState({
            selectedCampaigns: selectedCampaigns,
            selectedAdgroups: selectedAdgroups,
            allocatedBudgetByAccountIdAndItemId: allocatedBudgetByAccountIdAndItemId
        });

        this.props.onItemsSelectionChange(selectedItems, allocatedBudgetByAccountIdAndItemId[strAccountId]);
    }

    handleSelectionMethodChange(event) {
        const newSelectionMethod = event.target.value;
        if (this.state.selectionMethod === newSelectionMethod)
            return;

        if(!this.props.selectionMethodsAllowed.includes(newSelectionMethod)) {
            const { t } = this.props;
            alert(t('account_campaigns_config.agency_subscription_alert'));
            return;
        }

        const allocatedBudgetByAccountIdAndItemId = this.state.allocatedBudgetByAccountIdAndItemId;
        const strAccountId = this.props.selectedAccountId.toString();
        this.updateBudgetForSelectedItems([], allocatedBudgetByAccountIdAndItemId[strAccountId]);
        this.setState({
            selectionMethod: newSelectionMethod,
            selectedCampaigns: [],
            selectedAdgroups: [],
            allocatedBudgetByAccountIdAndItemId: allocatedBudgetByAccountIdAndItemId
        });

        this.props.onSelectionMethodChange(newSelectionMethod);
    };

    handleImportFromJson(dataForImport) {
        let selectedItems = this.isSelectionMethodSelectingCampaigns() ? this.state.selectedCampaigns : this.state.selectedAdgroups;
        const strAccountId = this.props.selectedAccountId.toString();
        const allocatedBudgetByItemId = this.state.allocatedBudgetByAccountIdAndItemId[strAccountId];
        const add = dataForImport.addUnSelectedItemsCheck;
        const hasItemId = this.isSelectionMethodSelectingCampaigns() ? dataForImport.jsonData[0].hasOwnProperty(CAMPAIGN_ID) : dataForImport.jsonData[0].hasOwnProperty(ADGROUP_ID);
        const columnToIdentifyItem = hasItemId ? (this.isSelectionMethodSelectingCampaigns()? CAMPAIGN_ID : ADGROUP_ID)  : (this.isSelectionMethodSelectingCampaigns()? CAMPAIGN_NAME : ADGROUP_NAME);

        const itemsIncludedInCSV = [];
        const itemsNotFoundInAccount = []
        dataForImport.jsonData.forEach(item => {
            const itemId = this.getItemIdFromJsonItem(item, columnToIdentifyItem);
            if(itemId !== null) {
                itemsIncludedInCSV.push(itemId);
                if(!selectedItems.includes(itemId)) {
                    if(add) {
                        selectedItems.push(itemId);
                        allocatedBudgetByItemId[itemId] = item[BUDGET];
                    }
                } else {
                    allocatedBudgetByItemId[itemId] = item[BUDGET];
                }
            }
            else
            {
                itemsNotFoundInAccount.push(item[this.isSelectionMethodSelectingCampaigns() ? CAMPAIGN_NAME : ADGROUP_NAME]);
            }
        });

        const remove = dataForImport.removeMissingSelectedItems;
        if(remove) {
            selectedItems = selectedItems.filter(itemId => itemsIncludedInCSV.includes(itemId));
        }

        const newAllocatedBudgetByAccountIdAndItemId = this.state.allocatedBudgetByAccountIdAndItemId;
        newAllocatedBudgetByAccountIdAndItemId[strAccountId] = allocatedBudgetByItemId;

        if (itemsNotFoundInAccount.length > 0) {
            const { t } = this.props;
            let message = this.isSelectionMethodSelectingCampaigns() ? t('account_campaigns_config.campaigns_not_found') : t('account_campaigns_config.adgroups_not_found');
            message += itemsNotFoundInAccount.join("\n");
            message += "\n\n\n" + t('account_campaigns_config.operation_continues');
            alert(message);
        }

        const selectedCampaigns = this.isSelectionMethodSelectingCampaigns() ? selectedItems : this.state.selectedCampaigns;
        const selectedAdgroups = this.isSelectionMethodSelectingAdgroups() ? selectedItems : this.state.selectedAdgroups;

        this.setState({
            selectedCampaigns: selectedCampaigns,
            selectedAdgroups: selectedAdgroups,
            allocatedBudgetByAccountIdAndItemId: newAllocatedBudgetByAccountIdAndItemId
        });

        this.props.onItemBudgetChange(allocatedBudgetByItemId, selectedCampaigns, selectedAdgroups);

    }

    getItemIdFromJsonItem(item, columnToIdentifyItem) {
        if(this.isSelectionMethodSelectingCampaigns()) {
            if(columnToIdentifyItem === CAMPAIGN_NAME)
                return this.getCampaignIdByName(item[CAMPAIGN_NAME]);
            else
                return item[CAMPAIGN_NAME];
        }

        if(this.isSelectionMethodSelectingAdgroups()) {
            if(columnToIdentifyItem === ADGROUP_NAME)
                return this.getAdgroupIdByName(item[ADGROUP_NAME]);
            else
                return item[ADGROUP_NAME];
        }
    }

    getCampaignIdByName(campaignName) {
        // Si en el CSV hay campañas que no está activas, esto va a fallar porque todavia no las trajimos
        const campaignData = this._getCampaignsData().find(obj => obj.name === campaignName)
        return campaignData ? campaignData.id : null;
    }

    getAdgroupIdByName(adgroupName) {
        // Si en el CSV hay adgroups que no está activas, esto va a fallar porque todavia no las trajimos
        const adgroupData = this._getAdgroupsData().find(obj => obj.name === adgroupName)
        return adgroupData ? adgroupData.id : null;
    }

    handleAddItems(itemsIds) {
        const selectedCampaigns = this.isSelectionMethodSelectingCampaigns() ? this.state.selectedCampaigns.concat(itemsIds) : [];
        const selectedAdgroups = this.isSelectionMethodSelectingAdgroups() ? this.state.selectedAdgroups.concat(itemsIds) : [];
        const selectedItems = selectedCampaigns.concat(selectedAdgroups); // Uno siempre va a estar vacio
        const strAccountId = this.props.selectedAccountId.toString();
        const allocatedBudgetByAccountIdAndItemId = this.state.allocatedBudgetByAccountIdAndItemId;
        this.updateBudgetForSelectedItems(selectedItems, allocatedBudgetByAccountIdAndItemId[strAccountId]);

        this.setState({
            selectedCampaigns: selectedCampaigns,
            selectedAdgroups: selectedAdgroups,
            allocatedBudgetByAccountIdAndItemId: allocatedBudgetByAccountIdAndItemId
        });

        this.props.onItemsSelectionChange(selectedItems, allocatedBudgetByAccountIdAndItemId[strAccountId]);
    }

    render() {
        const { t } = this.props;
        if(!this.props.adAccountHasConnection)
            return <Alert className="alert-warning filtering-alert">{t('account_campaigns_config.no_ad_account_access')}</Alert>

        return [
            this.renderSelectionMethodSelect(),
            this.renderIncludeAllCampaignsContent(),
            this.renderSelectCampaignsFromListContent(),
            this.renderSelectAdgroupsFromListContent(),
            this.renderIncludeCampaignsOnConditionContent(),
            this.renderIncludeAdgroupsOnConditionContent()
        ];
    }

    renderSelectionMethodSelect() {
        const { t } = this.props;
        if (this.state.onlyMethodSelectCampaignsFromList === true || this.state.onlyMethodSelectAdgroupsFromList)
            return;

        return <div key="selection_method" className="form-row">
            <label>{t('account_campaigns_config.selection_method_label')}</label>
            <select onChange={this.handleSelectionMethodChange} name="selectionMethod" required="required"
                    value={this.state.selectionMethod}>
                {/*{Object.keys(METHODS_DATA).map((method) => (
                    <option key={method} value={method}>
                        {METHODS_DATA[method]['Spanish']}
                    </option>
                ))}*/}
                <option key={METHOD_INCLUDE_ALL_CAMPAIGNS} value={METHOD_INCLUDE_ALL_CAMPAIGNS}>{t('account_campaigns_config.include_all_campaigns')}</option>
                <optgroup label={t('account_campaigns_config.some_campaigns')}>
                    <option key={METHOD_SELECT_CAMPAIGNS_FROM_LIST} value={METHOD_SELECT_CAMPAIGNS_FROM_LIST}>{t('account_campaigns_config.select_campaigns_manually')}</option>
                    <option key={METHOD_INCLUDE_CAMPAIGN_ON_CONDITION} value={METHOD_INCLUDE_CAMPAIGN_ON_CONDITION}>{t('account_campaigns_config.include_campaigns_automatically')}</option>
                </optgroup>

                <optgroup label={t('account_campaigns_config.some_adgroups')}>
                    <option key={METHOD_SELECT_ADGROUPS_FROM_LIST} value={METHOD_SELECT_ADGROUPS_FROM_LIST}>{t('account_campaigns_config.select_adgroups_manually')}</option>
                    <option key={METHOD_INCLUDE_ADGROUP_ON_CONDITION} value={METHOD_INCLUDE_ADGROUP_ON_CONDITION}>{t('account_campaigns_config.include_adgroups_automatically')}</option>
                </optgroup>
            </select>
        </div>;
    }

    renderIncludeCampaignsOnConditionContent() {
        if (this.state.selectionMethod !== METHOD_INCLUDE_CAMPAIGN_ON_CONDITION)
            return;

        return [this.renderConditionHeaderWithInput(), this.renderTableWithFilteredItems()];
    }

    renderIncludeAdgroupsOnConditionContent() {
        if (this.state.selectionMethod !== METHOD_INCLUDE_ADGROUP_ON_CONDITION)
            return;

        return [this.renderConditionHeaderWithInput(), this.renderTableWithFilteredItems()];
    }

    renderConditionHeaderWithInput() {
        const { t } = this.props;
        const includeText = this.isSelectionMethodSelectingCampaigns() ? t('account_campaigns_config.include_campaigns_text') : t('account_campaigns_config.include_adgroups_text');
        const excludeText = this.isSelectionMethodSelectingCampaigns() ? t('account_campaigns_config.exclude_campaigns_text') : t('account_campaigns_config.exclude_adgroups_text');

        const noteText = this.isSelectionMethodSelectingCampaigns() ? t('account_campaigns_config.campaigns_auto_add_note') : t('account_campaigns_config.adgroups_auto_add_note');


        return [<div className="p-3 mt-0" style={{backgroundColor: '#b6b6b7', border: '0'}}>
            <div className="row g-3">
                <div className="col-md-6">
                    <label>{includeText}<LinkToArticle article={HELP_INCLUDE_CAMPAIGNS_AUTOMATICALLY} /></label>
                    <input onChange={this.handleIncludeTextChange} name="include_text" type="text"
                           value={this.state.conditionIncludeText}/>
                </div>
                <div className="col-md-6">
                    <label>{excludeText}</label>
                    <input onChange={this.handleExcludeTextChange} name="exclude_text" type="text"
                           value={this.state.conditionExcludeText}/>
                </div>
            </div>
        </div>, <div className="field-footnote mt-2">{noteText}</div>];
    }

    renderSelectCampaignsFromListContent() {
        if (this.state.selectionMethod !== METHOD_SELECT_CAMPAIGNS_FROM_LIST)
            return;

        const campaignsAbleToSelect = this.getItemsFiltered();

        return [this.renderSectionWithButtons(campaignsAbleToSelect), this.renderTableWithSelectedCampaigns()
        ];
    }

    renderSelectAdgroupsFromListContent() {
        if (this.state.selectionMethod !== METHOD_SELECT_ADGROUPS_FROM_LIST)
            return;

        const adgroupsAbleToSelect = this.getItemsFiltered();

        return [this.renderSectionWithButtons(adgroupsAbleToSelect), this.renderTableWithSelectedAdgroups()
        ];
    }

    _getCampaignsData(){
        if(this.state.allNotActiveCampaigns === null)
            return [...this.state.allActiveCampaigns, ...this.state.someSelectedNotActiveCampaignsData]
        else
            return [...this.state.allActiveCampaigns, ...this.state.allNotActiveCampaigns];
    }

    _getAdgroupsData(){
        if(this.state.allNotActiveAdgroups === null)
            return [...this.state.allActiveAdgroups, ...this.state.someSelectedNotActiveAdgroupsData]
        else
            return [...this.state.allActiveAdgroups, ...this.state.allNotActiveAdgroups];
    }

    getItemsFiltered() {
        const someItemsData = this.isSelectionMethodSelectingCampaigns() ? this._getCampaignsData() : this._getAdgroupsData();
        const itemsIdsToFilter = this.isSelectionMethodSelectingCampaigns() ? this.state.selectedCampaigns : this.state.selectedAdgroups;
        return someItemsData.filter(c => !(itemsIdsToFilter.includes(c.id)));
    }

    filterItemsOnConditions(conditionIncludeText, conditionExcludeText) {
        if (this.textFieldHasNoValue(conditionIncludeText) && this.textFieldHasNoValue(conditionExcludeText))
            return []

        const itemsFromProps = this.isSelectionMethodSelectingCampaigns() ? this.state.allActiveCampaigns : this.state.allActiveAdgroups;

        return itemsFromProps.filter((c) => (c.is_active
            && (this.textFieldHasNoValue(conditionIncludeText) || conditionIncludeText.toLowerCase().split("|||").every(word => c.name.toLowerCase().includes(word.trim())))
            && (this.textFieldHasNoValue(conditionExcludeText) || !conditionExcludeText.toLowerCase().split("|||").some(word => word.trim() !== "" && c.name.toLowerCase().includes(word.trim()))))
        )
    }

    renderTableWithFilteredItems() {
        const { t } = this.props;
        const itemsFromProps = this.isSelectionMethodSelectingCampaigns() ? this._getCampaignsData() : this._getAdgroupsData();
        const itemsText = this.isSelectionMethodSelectingCampaigns() ? t('account_campaigns_config.campaigns') : t('account_campaigns_config.adgroups');

        if (itemsFromProps.length === 0) {
            const text = t('account_campaigns_config.no_items_or_importing', { items: itemsText });
            return <Alert className="alert-warning">{text}</Alert>;
        }

        if (this.textFieldHasNoValue(this.state.conditionIncludeText) && this.textFieldHasNoValue(this.state.conditionExcludeText)) {
            const text = t('account_campaigns_config.must_enter_text', { items: itemsText });
            return <Alert className="alert-warning">{text}</Alert>;
        }

        const itemsToShow = this.filterItemsOnConditions(this.state.conditionIncludeText, this.state.conditionExcludeText);
        const allowRemoving = false;

        return this.renderItemsTable(itemsToShow, true, t('account_campaigns_config.current_items_included', { items: this._capitalizeFirstWord(itemsText) }), allowRemoving)
    }

    _capitalizeFirstWord(str) {
        if (str.length === 0) return str; // Check if the string is empty
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    textFieldHasNoValue(textField) {
        return (textField === undefined || textField === null || textField === "");
    }

    renderTableWithSelectedCampaigns() {
        const { t } = this.props;
        if (this.state.selectedCampaigns.length > 0) {
            const campaignsToShow = this.getCampaignsFromCampaignsIds(this._getCampaignsData(), this.state.selectedCampaigns);
            const allowRemoving = true;
            const title = t('account_campaigns_config.selected_campaigns', { count: this.state.selectedCampaigns.length });

            return this.renderItemsTable(campaignsToShow, true, title, allowRemoving)
        } else {
            return <Alert className="alert-warning">{t('account_campaigns_config.no_campaigns_selected')}</Alert>;
        }
    }

    renderTableWithSelectedAdgroups() {
        const { t } = this.props;
        if (this.state.selectedAdgroups.length > 0) {
            const adgroupsToShow = this.getAdgroupsFromAdgroupsIds(this._getAdgroupsData(), this.state.selectedAdgroups);
            const allowRemoving = true;
            const title = t('account_campaigns_config.selected_adgroups', { count: this.state.selectedAdgroups.length });

            return this.renderItemsTable(adgroupsToShow, true, title, allowRemoving)
        } else {
            return <Alert className="alert-warning">{t('account_campaigns_config.no_adgroups_selected')}</Alert>;
        }
    }

    renderImportModalButton() {
        if (this.state.itemBudgetEdition !== true)
            return null;

        return <ImportFromCSVModal onFormSubmitted={this.handleImportFromJson}
                                   clickOutsideDontCloseModal={true}
                                   style={{float: "left"}}
                                   buttonClassName="btn -alt ml-2"/>;
    }

    renderSectionWithButtons(items) {
        if(this.isSelectionMethodSelectingCampaigns()) {
            return <div className="sectionWithButton pb-2 pt-2">
                <div className="right">
                    <SelectCampaignsMultiSelectModal onFormSubmitted={this.handleAddItems}
                                                     campaigns={items}
                                                     clickOutsideDontCloseModal={true}
                                                     style={{float: "left"}}
                                                     isUpdatingListItems={this.props.isUpdatingListItems}
                                                     messageForRefreshListItemsIconToolbox={this.props.messageForRefreshListItemsIconToolbox}
                                                     onRefreshListItems={this.props.onRefreshListItems}
                                                     onLoadInactiveItems={this.props.onLoadInactiveCampaigns}
                                                     inactiveItemsAreLoaded={this.props.allNotActiveCampaigns !== null && this.props.allNotActiveCampaigns !== undefined}
                                                     isLoadingInactiveItems={this.props.isLoadingInactiveItems}
                    />
                    {this.renderImportModalButton()}
                </div>
            </div>;
        } else if (this.isSelectionMethodSelectingAdgroups()) {
            return <div className="sectionWithButton pb-2 pt-2">
                <div className="right">
                    <SelectAdgroupsMultiSelectModal onFormSubmitted={this.handleAddItems}
                                                    adgroups={items}
                                                    clickOutsideDontCloseModal={true}
                                                    style={{float: "left"}}
                                                    isUpdatingListItems={this.props.isUpdatingListItems}
                                                    messageForRefreshListItemsIconToolbox={this.props.messageForRefreshListItemsIconToolbox}
                                                    onRefreshListItems={this.props.onRefreshListItems}
                                                    onLoadInactiveItems={this.props.onLoadInactiveAdgroups}
                                                    inactiveItemsAreLoaded={this.props.allNotActiveAdgroups !== null && this.props.allNotActiveAdgroups !== undefined}
                                                    isLoadingInactiveItems={this.props.isLoadingInactiveItems}


                    />
                    {this.renderImportModalButton()}
                </div>
            </div>;
        } else {
            throw Error("Method not implemented");
        }
    }

    getCampaignsFromCampaignsIds(campaigns, campaignsIds) {
        return campaigns.filter(campaign => campaignsIds.includes(campaign.id.toString()));
    }

    getAdgroupsFromAdgroupsIds(adgroups, adgroupsIds) {
        return adgroups.filter(adgroup => adgroupsIds.includes(adgroup.id.toString()));
    }

    renderIncludeAllCampaignsContent() {
        const { t } = this.props;
        if (this.state.selectionMethod !== METHOD_INCLUDE_ALL_CAMPAIGNS)
            return;

        return this.renderItemsTable(this.state.allActiveCampaigns.filter(c => c.is_active), true, t('account_campaigns_config.all_campaigns_active_only'), false);
    }

    getItemName(item) {
        if(item.campaign_name === undefined)
            return item.name;
        return `${item.campaign_name} ➡️ ${item.name}`
    }

    renderItemsTable(items, showHeader, headerText, allowRemoving) {
        const headerCells = (showHeader === true) ? <tr>
            <th style={{color: "#4a4a4a"}}>{headerText}</th>
            {this.renderBudgetEditionHeader()}
            {this.renderRemovingHeader(allowRemoving)}
        </tr> : null;

        const sortedItems = items.sort((a, b) => a.name.localeCompare(b.name));

        return <div className="table-box">
            <table className="table table-striped with-scroll table-header-gray" style={{maxHeight:"360px"}}>
                <thead>
                    {headerCells}
                </thead>
                <tbody>
                {sortedItems.map((item) => (
                    <tr key={item.id}>
                        <td>{this.getItemName(item)}</td>
                        {this.renderItemBudgetEditionCell(item.id)}
                        {this.renderItemRemovingCell(item, allowRemoving)}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>;
    }

    renderRemovingHeader(allowRemoving) {
        return (allowRemoving === true) ? <th></th> : null;
    }

    renderItemRemovingCell(item, allowRemoving) {
        if (allowRemoving === true) {
            return <td>
                <button onClick={(e) => this.handleRemoveItem(item.id)}><FaIcon className={"fa-solid"}
                                                                                key={item.id}
                                                                                iconName="ban"/></button>
            </td>;
        }

        return null;
    }

    renderBudgetEditionHeader() {
        const { t } = this.props;
        return (this.state.itemBudgetEdition === true) ? <th>{t('account_campaigns_config.budget')} {this.renderBudgetCurrency()}</th> : null;
    }

    renderBudgetCurrency() {
        if (!(this.props.canEditCurrency === true))
            return;

        return `(${this.props.budgetCurrency})`;
    }

    getAllocatedBudgetForItem(itemId) {
        const strAccountId = this.props.selectedAccountId.toString();
        const strItemId = itemId.toString();

        if (this.state.allocatedBudgetByAccountIdAndItemId[strAccountId] === undefined)
            return 0;

        if (this.state.allocatedBudgetByAccountIdAndItemId[strAccountId][strItemId] === undefined)
            return 0;

        return this.state.allocatedBudgetByAccountIdAndItemId[strAccountId][strItemId];
    }

    renderItemBudgetEditionCell(itemId) {
        if (this.state.itemBudgetEdition !== true)
            return null;

        const allocatedBudget = this.getAllocatedBudgetForItem(itemId);

        return (<td>
            <BudgetValueInput
                canEditCurrency={this.props.canEditCurrency}
                hideCurrency={true}
                budgetCurrency={this.props.budgetCurrency}
                currencyReadOnly={true}
                onCurrencyChange={null}
                onAmountChange={(event) => {
                    this.handleAllocatedBudgetChange(itemId, event)
                }}
                budgetAmount={allocatedBudget}/>
        </td>);
    }
}

export const AccountCampaignsConfiguration = withTranslation()(AccountCampaignsConfigurationClass);
export default AccountCampaignsConfiguration;
